// Lexical theme includes customizable theming object that maps CSS class names to the editor and css file. https://lexical.dev/docs/getting-started/theming

export const defaultTheme = {
  ltr: 'ltr',
  rtl: 'rtl',
  placeholder: 'editor-placeholder',
  paragraph: 'editor-paragraph',
  list: {
    nested: {
      listitem: 'editor-nested-listitem',
    },
    ol: 'editor-list-ol',
    ul: 'editor-list-ul',
    listitem: 'editor-listitem',
  },
  text: {
    bold: 'editor-text-bold',
    italic: 'editor-text-italic',
    overflowed: 'editor-text-overflowed',
    underline: 'editor-text-underline',
  },
  link: 'editor-link',
  hr: 'editor-hr',
};
